import { Injectable } from '@angular/core';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from 'app/storageprovider';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    private settingsSubject = new BehaviorSubject<any>({});
    settings$ = this.settingsSubject.asObservable();
    settingObj = {
        isDarkMode: true,
        isNSFWMode: true,
        isTCMode: false,
        isFriendOnly: true,
        isPipMode: true,
        isSkipMode: true,
        isShowDanmuMode: true,
        isPlayNextMode: true,
        isEmailBinded: false,
        isPhoneBinded: false,
        bindedEmail: '',
        isEnableZan: true,
        privateMsgAlam: 1, // 0: '仅关注的人', 1: '所有人'
        isEnableComment: true,
      };

    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper,
        private storageService: StorageService,
    ) { }

    loadSettings() {
        const apiURL = this._apiUrlHelper.urlBuilder('get-user-setting', {});
        this._httpClientHelper.get(apiURL).subscribe(res => {
            // console.log(res);
            if (!!res && res.code !== 401) {
                this.settingObj = res.map(r => {
                    return {
                        isDarkMode: r.isDarkMode,
                        isNSFWMode: r.isNSFWMode,
                        isTCMode: r.isTCMode,
                        isFriendOnly: r.isFriendOnly,
                        isPipMode: r.isPipMode,
                        isSkipMode: r.isSkipMode,
                        isShowDanmuMode: r.isShowDanmuMode,
                        isPlayNextMode: r.isPlayNextMode,
                        isEmailBinded: r.isEmailBinded,
                        isPhoneBinded: r.isPhoneBinded,
                        bindedEmail: r.bindedEmail,
                        isEnableZan: r.isEnableZan,
                        privateMsgAlam: r.privateMsgAlam,
                        isEnableComment: r.isEnableComment,
                    }
                })[0];
            }
            this.settingsSubject.next(this.settingObj);
            // console.log('initSettingLoaded', this.settingObj);
            this.switchPipMode();
            this.switchSkipMode();
            this.switchPlayNextMode();
        });
    }

    updateSettings(settings: any) {
        const apiURL = this._apiUrlHelper.urlBuilder('set-user-setting', {});
        this._httpClientHelper.post(apiURL, settings, null).subscribe(res => {
            // console.log(res);
        });
        this.settingObj = settings;
        this.settingsSubject.next(this.settingObj);
        // console.log('updatedSetting', this.settingObj);
        this.switchPipMode();
        this.switchSkipMode();
        this.switchPlayNextMode();
    }

    updateOneSetting(setting: any) {
        const combinedSettings = {
            ...this.settingObj,
            ...setting,
        };
        this.updateSettings(combinedSettings);
    }

    switchPipMode() {
        // 向storageconfig更新切换后的画中画设置
        this.storageService.SetConfig({
            forbiddenFloatingPlayer: !this.settingObj.isPipMode ? 1 : 0
        })
    }

    switchSkipMode() {
        // 向storageconfig更新切换后的跳过设置
        this.storageService.SetConfig({
            autoSkip: this.settingObj.isSkipMode ? 1 : 0
        })
    }

    switchPlayNextMode() {
        // 向storageconfig更新切换后的自动下一集设置
        this.storageService.SetConfig({
            autoNext: this.settingObj.isPlayNextMode ? 1 : 0
        });
    }

    resetPassword(pwdObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('reset-password', {});
        return this._httpClientHelper.post(apiURL, pwdObj, null);
    }

    bindInfo(infoObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('bind-info', {});
        return this._httpClientHelper.post(apiURL, infoObj, null);
    }

    applyCode(applyObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('apply-code', {});
        return this._httpClientHelper.post(apiURL, applyObj, null, true);
    }

    isValidCode(validObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('is-valid-code', {});
        return this._httpClientHelper.post(apiURL, validObj, null, true);
    }

    updateMobile(infoObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('update-mobile', {});
        return this._httpClientHelper.post(apiURL, infoObj, null);
    }

    updateAvatar(avatarObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('update-avatar', {});
        return this._httpClientHelper.post(apiURL, avatarObj, null, true);
    }

    getUserInfo() {
        const apiURL = this._apiUrlHelper.urlBuilder('get-setting-user-info', {});
        return this._httpClientHelper.get(apiURL);
    }

    updateUserInfo(userInfoObj) {
        const apiURL = this._apiUrlHelper.urlBuilder('update-setting-user-info', {});
        return this._httpClientHelper.post(apiURL, userInfoObj, null);
    }
}